import {
  ACTION_1,
  ACTIVATE_FORM,
  ACTIVATE_USER,
  ADD_ITEM_TO_CART,
  ALERT_HIDE,
  ALERT_SHOW,
  ALERT_TIMEOUT,
  CHECK_AUTH_DONE,
  CHECK_AUTH_FAILED,
  CHECK_AUTH_START,
  COPY_FORM_TO_FORM_GROUP_DONE,
  COPY_FORM_TO_FORM_GROUP_FAILED,
  COPY_FORM_TO_FORM_GROUP_START,
  CREATE_FILLED_FORM_DATA_DONE,
  CREATE_FILLED_FORM_DATA_FAILED,
  CREATE_FILLED_FORM_DATA_START,
  DEACTIVATE_FORM,
  DONE,
  DUPLICATE_FORM,
  EDIT_ITEM_CART,
  FAILED,
  FETCH_ACTIVATED_KITS,
  FETCH_ACTIVE_FORMS,
  FETCH_USER_ALL_FORMS,
  FETCH_PLANNED_FORMS,
  FETCH_ARCHIVED_FORMS,
  FETCH_ALL_MY_TESTS,
  FETCH_ALL_TERMS,
  FETCH_CONFIG_GLOBAL_DONE,
  FETCH_CONFIG_GLOBAL_FAILED,
  FETCH_CONFIG_GLOBAL_START,
  FETCH_DATA_AS_CSV,
  FETCH_FILLED_FORMS_DONE,
  FETCH_FILLED_FORMS_EXTENDED,
  FETCH_FILLED_FORMS_FAILED,
  FETCH_FILLED_FORMS_START,
  FETCH_FILLED_TESTS,
  FETCH_FORM_TEMPLATE_DONE,
  FETCH_FORM_TEMPLATE_FAILED,
  FETCH_FORM_TEMPLATE_START,
  FETCH_FORM_DONE,
  FETCH_FORM_EDITIONS,
  FETCH_FORM_FAILED,
  FETCH_FORM_GROUP_DONE,
  FETCH_FORM_GROUP_FAILED,
  FETCH_FORM_GROUP_START,
  FETCH_GLOBAL_DICTIONARIES_DONE,
  FETCH_GLOBAL_DICTIONARIES_FAILED,
  FETCH_GLOBAL_DICTIONARIES_START,
  FETCH_FORM_START,
  FETCH_FORMS_DONE,
  FETCH_FORMS_FAILED,
  FETCH_FORMS_GROUPS_DONE,
  FETCH_FORMS_GROUPS_FAILED,
  FETCH_FORMS_GROUPS_START,
  FETCH_FORMS_START,
  FETCH_OLD_FORM_EDITIONS,
  FETCH_ORDER_DETAILS_BY_ORDER_ID,
  FETCH_ORG_NAMES_DONE,
  FETCH_ORG_NAMES_FAILED,
  FETCH_ORG_NAMES_START,
  FETCH_ORG_USERS_DONE,
  FETCH_ORG_USERS_FAILED,
  FETCH_ORG_USERS_START,
  FETCH_ORGANIZATION_DONE,
  FETCH_ORGANIZATION_FAILED,
  FETCH_ORGANIZATION_START,
  FETCH_SCHEDULED_FORMS,
  INVITE_MULTIPLE_PEOPLE_DONE,
  INVITE_MULTIPLE_PEOPLE_FAILED,
  INVITE_MULTIPLE_PEOPLE_START,
  JOIN_ORGANIZATION_DONE,
  JOIN_ORGANIZATION_FAILED,
  JOIN_ORGANIZATION_START,
  LOGIN_DONE,
  LOGIN_FAILED,
  LOGIN_START,
  LOGOUT_DONE,
  LOGOUT_FAILED,
  LOGOUT_START,
  MOVE_FORM_TO_FORM_GROUP_DONE,
  MOVE_FORM_TO_FORM_GROUP_FAILED,
  MOVE_FORM_TO_FORM_GROUP_START,
  RECOVER_PASSWORD_DONE,
  RECOVER_PASSWORD_FAILED,
  RECOVER_PASSWORD_START,
  RESET_BY_MAIL_PASSWORD_DONE,
  RESET_BY_MAIL_PASSWORD_FAILED,
  RESET_BY_MAIL_PASSWORD_START,
  REGISTER_ORGANIZATION_DONE,
  REGISTER_ORGANIZATION_FAILED,
  REGISTER_ORGANIZATION_START,
  REMOVE_FORM_DONE,
  REMOVE_FORM_FAILED,
  REMOVE_FORM_FROM_FORM_GROUP_DONE,
  REMOVE_FORM_FROM_FORM_GROUP_FAILED,
  REMOVE_FORM_FROM_FORM_GROUP_START,
  REMOVE_FORM_START,
  REMOVE_ITEM_FROM_CART,
  REMOVE_USER,
  EDIT_USER,
  SAVE_FILLED_FORM_DATA_DONE,
  SAVE_FILLED_FORM_DATA_FAILED,
  SAVE_FILLED_FORM_DATA_START,
  EDIT_FILLED_FORM_DATA_DONE,
  EDIT_FILLED_FORM_DATA_FAILED,
  EDIT_FILLED_FORM_DATA_START,
  SAVE_FORM_DONE,
  SAVE_FORM_FAILED,
  SAVE_FORM_START,
  SAVE_FORM_GROUP_DONE,
  SAVE_FORM_GROUP_FAILED,
  SAVE_FORM_GROUP_START,
  SEND_COMMENT_DONE,
  SEND_COMMENT_FAILED,
  SEND_COMMENT_START,
  SET_APP_BAR_TITLE,
  START,
  TOGGLE_REQUESTED_SHARING_BY_OWNER,
  UPDATE_ENTITLED_USERS,
  UPDATE_FORM_DATA_IS_SHARED,
  UPDATE_FORM_DONE,
  UPDATE_FORM_FAILED,
  UPDATE_FORM_START,
  UPDATE_REQUESTED_SHARING_BY_OWNER,
  REMOVE_FORM_GROUP,
  ADD_PERSON,
  DUPLICATE_FORM_GROUP,
  FETCH_ALLOWED_USERS_TO_GROUP_START,
  FETCH_ALLOWED_USERS_TO_GROUP_DONE,
  FETCH_ALLOWED_USERS_TO_GROUP_FAILED,
  FETCH_ALLOWED_USERS_TO_FORM_START,
  FETCH_ALLOWED_USERS_TO_FORM_DONE,
  FETCH_ALLOWED_USERS_TO_FORM_FAILED,
  UPDATE_USERS_ACCESS_TO_GROUP,
  UPDATE_USERS_ACCESS_TO_FORM,
  FETCH_FORM_DATA,
  FETCH_UPLOADABLE_FILE_TYPES,
  FETCH_SAVED_FORM_DATA,
  FETCH_FILLED_FORM_DATA,
  REMOVE_FORM_DATA_DRAFT,
  FETCH_MATCHING_USERS,
  FETCH_FORMS_SCHEDULED_FOR_FUTURE,
  RESET_GIVEN_USER_PASSWORD,
  FETCH_API_KEYS,
  ADD_API_KEY,
  DELEETE_API_KEY,
  FETCH_SCHEDULED_FORM,
  FETCH_HAS_SINGLE_SCHEDULED_FORM,
  ALERT_HIDE_CUSTOM_ID,
  TOGGLE_GLOBAL_THEME,
  READ_GLOBAL_THEME,
  SMALL_FONT_SIZE,
  MEDIUM_FONT_SIZE,
  LARGE_FONT_SIZE,
  FETCH_CONFIG,
  CLEAR_ALL_FORM,
} from "../../constants";
import { getAxiosInstance, refreshAxios } from "../common";
import { fetchPendingTerms } from "../organization/actions";

refreshAxios();

export const action1 = (payload) => ({ type: ACTION_1, payload });

/**
 *
 * @param payload {name, mail, password}
 * @returns {Function}
 */
export const register_organization = (payload) => async (dispatch) => {
  dispatch(register_organization_start());
  try {
    refreshAxios();

    const result = await getAxiosInstance().post(
      "/api/organizations/register",
      {
        orgName: payload.name,
        mail: payload.mail,
        password: payload.password,
      }
    );

    dispatch(register_organization_done(result.data));
    return result;
  } catch (e) {
    dispatch(register_organization_failed(e));
    return e.response;
  }
};

export const join_organization = (payload) => async (dispatch) => {
  dispatch(join_organization_start());
  try {
    refreshAxios();

    const result = await getAxiosInstance().post(
      `/api/organizations/${payload.selectedOrg}/join`,
      {
        mail: payload.mail,
        password: payload.password,
        ...(payload.orgCode ? { orgCode: payload.orgCode } : {}),
      }
    );

    dispatch(join_organization_done(result.data));
    return result.data;
  } catch (e) {
    dispatch(join_organization_failed(e));
    throw e;
  }
};

export const register_organization_start = (payload) => ({
  type: REGISTER_ORGANIZATION_START,
  payload,
});
export const register_organization_done = (payload) => ({
  type: REGISTER_ORGANIZATION_DONE,
  payload,
});
export const register_organization_failed = (payload) => ({
  type: REGISTER_ORGANIZATION_FAILED,
  payload,
});

export const join_organization_start = (payload) => ({
  type: JOIN_ORGANIZATION_START,
  payload,
});
export const join_organization_done = (payload) => ({
  type: JOIN_ORGANIZATION_DONE,
  payload,
});
export const join_organization_failed = (payload) => ({
  type: JOIN_ORGANIZATION_FAILED,
  payload,
});

/**
 *
 * @param payload {username, password}
 * @returns {Function}
 */
export const login = (payload, loginType) => async (dispatch) => {
  dispatch(login_start());
  try {
    refreshAxios();
    const result =
      loginType !== "patient"
        ? await getAxiosInstance().post("/api/auth/login-employee", {
            username: payload.username,
            password: payload.password,
          })
        : await getAxiosInstance().post(
            "/api/auth/login",
            payload.username === "" || payload.username === undefined
              ? {
                  phone: payload.phone,
                  password: payload.password,
                  globalTosAccepted: payload.globalTosAccepted,
                }
              : {
                  username: payload.username,
                  password: payload.password,
                  globalTosAccepted: payload.globalTosAccepted,
                }
          );

    refreshAxios(result.data.token);

    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(
      login_done({
        data: result.data,
        my: my.data,
      })
    );

    // Prime pendingTerms in Redux before the user gets a chance to navigate.
    // The TermsAcceptanceFilter whitelists /api/persons/my, so the login flow
    // itself never triggers the axios 403 interceptor that would redirect to
    // /terms-accept — and PrivateRoute's terms guard needs state.pendingTerms
    // populated to fire on the first navigation.
    try {
      await dispatch(fetchPendingTerms());
    } catch (e) {
      // Non-fatal: axios interceptor + terms-accept page's own fetch will
      // recover on the first blocked API call.
    }

    window &&
      window.localStorage &&
      window.localStorage.setItem("loggedIn", new Date().toISOString());

    if (window && window.localStorage && payload.username) {
      window.localStorage.setItem("rememberMeLogin", payload.username);
    }

    if (window && window.localStorage) {
      window.localStorage.setItem(
        "loginType",
        loginType === "patient" ? "patient" : "employee"
      );
    }

    return result;
  } catch (e) {
    dispatch(login_failed(e));
    return e.response;
  }
};

export const login_start = (payload) => ({ type: LOGIN_START, payload });
export const login_done = (payload) => ({ type: LOGIN_DONE, payload });
export const login_failed = (payload) => ({
  type: LOGIN_FAILED,
  errorMessage: payload.response.data.message,
  payload,
});

export const checkAuth = (payload) => async (dispatch) => {
  dispatch(checkAuth_start());
  try {
    await refreshAxios();

    // const result = await getAxiosInstance().get("/api/auth/refresh");

    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(
      checkAuth_done({
        // token: result.data.token,
        my: my.data,
      })
    );
    return true;
  } catch (e) {
    dispatch(checkAuth_failed(e));
    return false;
  }
};

export const checkAuth_start = (payload) => ({
  type: CHECK_AUTH_START,
  payload,
});
export const checkAuth_done = (payload) => ({ type: CHECK_AUTH_DONE, payload });
export const checkAuth_failed = (payload) => ({
  type: CHECK_AUTH_FAILED,
  payload,
});

export const fetchOrgUsers = (payload) => async (dispatch) => {
  dispatch(fetchOrgUsers_start());
  try {
    const result = await getAxiosInstance().get("/api/persons");

    dispatch(fetchOrgUsers_done({ users: result.data }));
    return true;
  } catch (e) {
    dispatch(fetchOrgUsers_failed(e));
    return false;
  }
};

export const fetchOrgUsers_start = (payload) => ({
  type: FETCH_ORG_USERS_START,
  payload,
});

export const fetchOrgUsers_done = (payload) => ({
  type: FETCH_ORG_USERS_DONE,
  payload,
});

export const fetchOrgUsers_failed = (payload) => ({
  type: FETCH_ORG_USERS_FAILED,
  payload,
});

export const fetchOrgNames = (payload) => async (dispatch) => {
  dispatch(fetchOrgNames_start());
  try {
    const result = await getAxiosInstance().get("/api/organizations/names");
    dispatch(fetchOrgNames_done({ orgNames: result.data }));
    return result.data;
  } catch (e) {
    dispatch(fetchOrgNames_failed(e));
    return false;
  }
};

export const fetchOrgNames_start = (payload) => ({
  type: FETCH_ORG_NAMES_START,
  payload,
});
export const fetchOrgNames_done = (payload) => ({
  type: FETCH_ORG_NAMES_DONE,
  payload,
});
export const fetchOrgNames_failed = (payload) => ({
  type: FETCH_ORG_NAMES_FAILED,
  payload,
});

export const addPerson = ({ person, orgId }) => async (dispatch) => {
  dispatch({ type: ADD_PERSON + START });

  try {
    const res = await getAxiosInstance().post(
      `/api/organizations/${orgId}/add_user`,
      person
    );
    dispatch({ type: ADD_PERSON + DONE, payload: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: ADD_PERSON + FAILED, payload: e });
    throw e;
  }
};

export const inviteMultiplePeople = (payload) => async (dispatch) => {
  dispatch(inviteMultiplePeople_start());

  try {
    const res = await getAxiosInstance().post(
      `/api/organizations/${payload.orgId}/add_users`,
      payload.persons
    );

    dispatch(inviteMultiplePeople_done({ users: res }));
    return res.data;
  } catch (e) {
    dispatch(inviteMultiplePeople_failed(e));
    return {
      error: e,
    };
  }
};

export const inviteMultiplePeople_start = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_START,
  payload,
});

export const inviteMultiplePeople_done = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_DONE,
  payload,
});

export const inviteMultiplePeople_failed = (payload) => ({
  type: INVITE_MULTIPLE_PEOPLE_FAILED,
  payload,
});

//////////// logout

export const logout = ({ isUser } = {}) => async (dispatch) => {
  dispatch(logoutStart());

  try {
    const result = isUser
      ? await getAxiosInstance().post("/api/auth/logout")
      : await getAxiosInstance().post("/api/auth/logout");
    dispatch(logoutDone(result));

    window &&
      window.localStorage &&
      window.localStorage.setItem("loggedOut", new Date().toISOString());

    return true;
  } catch (e) {
    dispatch(logoutFailed());
  }

  return false;
};

export const logoutStart = (payload) => ({ type: LOGOUT_START, payload });

export const logoutDone = (payload) => ({ type: LOGOUT_DONE, payload });

export const logoutFailed = (payload) => ({ type: LOGOUT_FAILED, payload });

//// save  form

const FORM_ERROR_MESSAGES = {
  "form-description-too-long": "Opis formularza jest za długi (maks. 255 znaków).",
};

const dispatchFormErrorAlert = (dispatch, e) => {
  const code = e?.response?.data?.message;
  const text = FORM_ERROR_MESSAGES[code] || "Nie udało się zapisać formularza.";
  dispatch(alertAdd({ text, isError: true }));
};

export const saveForm = (payload) => async (dispatch) => {
  dispatch(saveFormStart());
  try {
    const result = await getAxiosInstance().post(`/api/forms`, payload);
    dispatch(saveFormDone(result.data));
    dispatch(fetchHasSingleScheduledForm());
    return result.data;
  } catch (e) {
    dispatch(saveFormFailed(e));
    dispatchFormErrorAlert(dispatch, e);
    return null;
  }
};

export const saveFormStart = (payload) => ({ type: SAVE_FORM_START, payload });

export const saveFormDone = (payload) => ({ type: SAVE_FORM_DONE, payload });

export const saveFormFailed = (payload) => ({
  type: SAVE_FORM_FAILED,
  payload,
});

//// update  form

export const updateForm = (id, payload) => async (dispatch) => {
  dispatch(updateFormStart());
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}`, payload);
    dispatch(updateFormDone(result.data));
    dispatch(fetchHasSingleScheduledForm());
    return result.data;
  } catch (e) {
    dispatch(updateFormFailed(e));
    dispatchFormErrorAlert(dispatch, e);
    return null;
  }
};
const updateFormStart = (payload) => ({ type: UPDATE_FORM_START, payload });
const updateFormDone = (payload) => ({ type: UPDATE_FORM_DONE, payload });
const updateFormFailed = (payload) => ({ type: UPDATE_FORM_FAILED, payload });

//// save  form group

export const saveFormGroup = (payload) => async (dispatch) => {
  dispatch(saveFormGroupStart());
  try {
    const result = await getAxiosInstance().post(`/api/form_group`, payload);
    dispatch(saveFormGroupDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(saveFormGroupFailed(e));
    return null;
  }
};

export const saveFormGroupStart = (payload) => ({
  type: SAVE_FORM_GROUP_START,
  payload,
});

export const saveFormGroupDone = (payload) => ({
  type: SAVE_FORM_GROUP_DONE,
  payload,
});

export const saveFormGroupFailed = (payload) => ({
  type: SAVE_FORM_GROUP_FAILED,
  payload,
});

//// remove form group

export const removeFormGroup = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_FORM_GROUP + START });
  try {
    const result = await getAxiosInstance().delete(`/api/form_group/${id}`);
    dispatch({ type: REMOVE_FORM_GROUP + DONE, payload: id });
    return result.data;
  } catch (e) {
    dispatch({ type: REMOVE_FORM_GROUP + FAILED, payload: e });
  }
};

//// update  form group

export const updateFormGroup = (id, payload) => async (dispatch) => {
  dispatch(updateFormGroupStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${id}`,
      payload
    );
    dispatch(updateFormGroupDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(updateFormGroupFailed(e));
    return null;
  }
};
const updateFormGroupStart = (payload) => ({
  type: UPDATE_FORM_START,
  payload,
});
const updateFormGroupDone = (payload) => ({ type: UPDATE_FORM_DONE, payload });
const updateFormGroupFailed = (payload) => ({
  type: UPDATE_FORM_FAILED,
  payload,
});

export const duplicateFormGroup = (id, payload) => async (dispatch) => {
  dispatch({ type: DUPLICATE_FORM_GROUP + START, id });
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${id}/duplicate`,
      payload
    );

    dispatch({ type: DUPLICATE_FORM_GROUP + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: DUPLICATE_FORM_GROUP + FAILED, id });
    return null;
  }
};

export const duplicateForm = (id) => async (dispatch) => {
  dispatch({ type: DUPLICATE_FORM + START, id });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/duplicate`);
    dispatch({ type: DUPLICATE_FORM + DONE, payload: result.data });
    dispatch(fetchHasSingleScheduledForm());
    return result.data;
  } catch (e) {
    dispatch({ type: DUPLICATE_FORM + FAILED, id });
    return null;
  }
};

export const deactivateForm = (id) => async (dispatch) => {
  dispatch({ type: DEACTIVATE_FORM + START, id });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/deactivate`);
    dispatch({ type: DEACTIVATE_FORM + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: DEACTIVATE_FORM + FAILED, id });
    return null;
  }
};

//// fetch org

export const fetchOrganization = (payload, orgId) => async (dispatch) => {
  dispatch(fetchOrganizationStart());
  try {
    const result = await getAxiosInstance().get(
      "/api/persons/my/organizations"
    );
    dispatch(fetchOrganizationDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchOrganizationFailed(e));
  }
};

export const fetchOrganizationStart = (payload) => ({
  type: FETCH_ORGANIZATION_START,
  payload,
});

export const fetchOrganizationDone = (payload) => ({
  type: FETCH_ORGANIZATION_DONE,
  payload,
});

export const fetchOrganizationFailed = (payload) => ({
  type: FETCH_ORGANIZATION_FAILED,
  payload,
});

/////////////

export const fetchConfigGlobal = (payload, orgId) => async (dispatch) => {
  dispatch(fetchConfigGlobalStart());
  try {
    const result = await getAxiosInstance().get("/api/config_global");
    dispatch(fetchConfigGlobalDone(result.data));
    return result.data;
  } catch (e) {
    dispatch(fetchConfigGlobalFailed(e));
  }
};

export const fetchConfigGlobalStart = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_START,
  payload,
});

export const fetchConfigGlobalDone = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_DONE,
  payload,
});

export const fetchConfigGlobalFailed = (payload) => ({
  type: FETCH_CONFIG_GLOBAL_FAILED,
  payload,
});

export const fetchFormsStart = (payload) => ({
  type: FETCH_FORMS_START,
  payload,
});
export const fetchFormsDone = (payload) => ({
  type: FETCH_FORMS_DONE,
  payload,
});
export const fetchFormsFailed = (payload) => ({
  type: FETCH_FORMS_FAILED,
  payload,
});

export const fetchForms = (payload) => async (dispatch) => {
  dispatch(fetchFormsStart());
  try {
    const forms = (await getAxiosInstance().get("/api/forms")).data;

    dispatch(fetchFormsDone(forms));
    return true;
  } catch (e) {
    dispatch(fetchFormsFailed(e));
    return false;
  }
};

export const fetchFormsGroupsStart = (payload) => ({
  type: FETCH_FORMS_GROUPS_START,
  payload,
});
export const fetchFormsGroupsDone = (payload) => ({
  type: FETCH_FORMS_GROUPS_DONE,
  payload,
});
export const fetchFormsGroupsFailed = (payload) => ({
  type: FETCH_FORMS_GROUPS_FAILED,
  payload,
});

export const fetchFormsGroups = () => async (dispatch) => {
  dispatch(fetchFormsGroupsStart());
  try {
    const data = (await getAxiosInstance().get(`/api/form_group`)).data;

    dispatch(fetchFormsGroupsDone(data));
    return true;
  } catch (e) {
    dispatch(fetchFormsGroupsFailed(e));
    return false;
  }
};

export const fetchAllowedUsersToGroupStart = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_START,
  payload,
});
export const fetchAllowedUsersToGroupDone = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_DONE,
  payload,
});
export const fetchAllowedUsersToGroupFailed = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_GROUP_FAILED,
  payload,
});

export const fetchAllowedUsersToGroup = (groupId) => async (dispatch) => {
  dispatch(fetchAllowedUsersToGroupStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_group/${groupId}/allowed_users`)
    ).data;
    dispatch(fetchAllowedUsersToGroupDone(data));
    return true;
  } catch (e) {
    dispatch(fetchAllowedUsersToGroupFailed(e));
    return false;
  }
};

export const fetchAllowedUsersToFormStart = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_START,
  payload,
});
export const fetchAllowedUsersToFormDone = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_DONE,
  payload,
});
export const fetchAllowedUsersToFormFailed = (payload) => ({
  type: FETCH_ALLOWED_USERS_TO_FORM_FAILED,
  payload,
});

export const fetchAllowedUsersToForm = (formId) => async (dispatch) => {
  dispatch(fetchAllowedUsersToFormStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/forms/${formId}/allowed_users`)
    ).data;
    dispatch(fetchAllowedUsersToFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchAllowedUsersToFormFailed(e));
    return false;
  }
};

export const copyFormToFormGroupStart = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_START,
  payload,
});
export const copyFormToFormGroupDone = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_DONE,
  payload,
});
export const copyFormToFormGroupFailed = (payload) => ({
  type: COPY_FORM_TO_FORM_GROUP_FAILED,
  payload,
});

export const copyFormToFormGroup = (formId, groupId) => async (dispatch) => {
  dispatch(copyFormToFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/clone_form_to_group/${formId}/${groupId}`
      )
    ).data;

    dispatch(copyFormToFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(copyFormToFormGroupFailed(e));
    return false;
  }
};

export const removeFormFromFormGroupStart = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_START,
  payload,
});
export const removeFormFromFormGroupDone = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_DONE,
  payload,
});
export const removeFormFromFormGroupFailed = (payload) => ({
  type: REMOVE_FORM_FROM_FORM_GROUP_FAILED,
  payload,
});

export const removeFormFromFormGroup = (formId) => async (dispatch) => {
  dispatch(removeFormFromFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/detach_form_from_group/${formId}`
      )
    ).data;

    dispatch(removeFormFromFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(removeFormFromFormGroupFailed(e));
    return false;
  }
};

export const moveFormToFormGroupStart = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_START,
  payload,
});
export const moveFormToFormGroupDone = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_DONE,
  payload,
});
export const moveFormToFormGroupFailed = (payload) => ({
  type: MOVE_FORM_TO_FORM_GROUP_FAILED,
  payload,
});

export const moveFormToFormGroup = (formId, targetGroupId) => async (
  dispatch
) => {
  dispatch(moveFormToFormGroupStart());
  try {
    const data = (
      await getAxiosInstance().post(
        `/api/form_group/move_form_to_group/${formId}/${targetGroupId}`
      )
    ).data;

    dispatch(moveFormToFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(moveFormToFormGroupFailed(e));
    return false;
  }
};

export const fetchScheduledForms = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_SCHEDULED_FORMS + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/scheduled")).data;

    dispatch({ type: FETCH_SCHEDULED_FORMS + DONE, payload: forms });
    return true;
  } catch (e) {
    dispatch({ type: FETCH_SCHEDULED_FORMS + FAILED, payload: e });
    return false;
  }
};

export const fetchActiveForms = () => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVE_FORMS + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/active")).data;

    dispatch({ type: FETCH_ACTIVE_FORMS + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ACTIVE_FORMS + FAILED });
  }
};

export const fetchUserAllForms = (personId) => async (dispatch) => {
  dispatch({ type: FETCH_USER_ALL_FORMS + START });
  try {
    const forms = (
      await getAxiosInstance().get(`/api/forms/active-by-person/${personId}`)
    ).data;

    dispatch({ type: FETCH_USER_ALL_FORMS + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_USER_ALL_FORMS + FAILED });
  }
};

export const fetchPlannedForms = () => async (dispatch) => {
  dispatch({ type: FETCH_PLANNED_FORMS + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/scheduled")).data;

    dispatch({ type: FETCH_PLANNED_FORMS + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_PLANNED_FORMS + FAILED });
  }
};

export const fetchArchivedForms = () => async (dispatch) => {
  dispatch({ type: FETCH_ARCHIVED_FORMS + START });
  try {
    const forms = (await getAxiosInstance().get("/api/forms/all-my-filled"))
      .data;

    dispatch({ type: FETCH_ARCHIVED_FORMS + DONE, payload: forms });
    return forms;
  } catch (e) {
    dispatch({ type: FETCH_ARCHIVED_FORMS + FAILED });
  }
};

export const fetchSavedFormData = () => async (dispatch) => {
  dispatch({ type: FETCH_SAVED_FORM_DATA + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/form_data/all/my", {
        params: {
          state: "SAVED",
        },
      })
    ).data;

    dispatch({ type: FETCH_SAVED_FORM_DATA + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_SAVED_FORM_DATA + FAILED });
  }
};

export const fetchFilledFormData = () => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_FORM_DATA + START });
  try {
    const forms = (
      await getAxiosInstance().get("/api/form_data/all/my", {
        params: {
          state: "COMPLETED",
        },
      })
    ).data;

    dispatch({ type: FETCH_FILLED_FORM_DATA + DONE, payload: forms });
  } catch (e) {
    dispatch({ type: FETCH_FILLED_FORM_DATA + FAILED });
  }
};

export const removeDraft = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_FORM_DATA_DRAFT + START });
  try {
    const response = await getAxiosInstance().delete(`/api/form_data/${id}`);
    dispatch({ type: REMOVE_FORM_DATA_DRAFT + DONE, payload: { id } });
    return response;
  } catch (e) {
    dispatch({ type: REMOVE_FORM_DATA_DRAFT + FAILED });
    return e.response;
  }
};

/////////////

export const removeFormStart = (payload) => ({
  type: REMOVE_FORM_START,
  payload,
});
export const removeFormDone = (payload) => ({
  type: REMOVE_FORM_DONE,
  payload,
});
export const removeFormFailed = (payload) => ({
  type: REMOVE_FORM_FAILED,
  payload,
});

export const removeForm = (payload) => async (dispatch) => {
  dispatch(removeFormStart());
  try {
    await getAxiosInstance().delete(`/api/forms/${payload}`);

    dispatch(removeFormDone(payload));
    dispatch(fetchHasSingleScheduledForm());
    return true;
  } catch (e) {
    dispatch(removeFormFailed(e));
    return false;
  }
};

/////////////

export const fetchFormTemplateStart = (payload) => ({
  type: FETCH_FORM_TEMPLATE_START,
  payload,
});
export const fetchFormTemplateDone = (payload) => ({
  type: FETCH_FORM_TEMPLATE_DONE,
  payload,
});
export const fetchFormTemplateFailed = (payload) => ({
  type: FETCH_FORM_TEMPLATE_FAILED,
  payload,
});

export const fetchFormTemplate = (formDataId) => async (dispatch) => {
  dispatch(fetchFormTemplateStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_template/${formDataId}`)
    ).data;

    dispatch(fetchFormTemplateDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormTemplateFailed(e));
    return null;
  }
};

/////////////

export const fetchFormStart = (payload) => ({
  type: FETCH_FORM_START,
  payload,
});
export const fetchFormDone = (payload) => ({ type: FETCH_FORM_DONE, payload });
export const fetchFormFailed = (payload) => ({
  type: FETCH_FORM_FAILED,
  payload,
});

export const fetchForm = (id) => async (dispatch) => {
  dispatch(fetchFormStart());
  try {
    const data = (await getAxiosInstance().get(`/api/forms/${id}`)).data;

    dispatch(fetchFormDone(data));
    return data;
  } catch (e) {
    dispatch(fetchFormFailed(e));
    return null;
  }
};

/////////////
export const fetchFormGroupStart = (payload) => ({
  type: FETCH_FORM_GROUP_START,
  payload,
});
export const fetchFormGroupDone = (payload) => ({
  type: FETCH_FORM_GROUP_DONE,
  payload,
});
export const fetchFormGroupFailed = (payload) => ({
  type: FETCH_FORM_GROUP_FAILED,
  payload,
});

export const fetchFormGroup = (id) => async (dispatch) => {
  dispatch(fetchFormGroupStart());
  try {
    const data = (await getAxiosInstance().get(`/api/form_group/${id}`)).data;

    dispatch(fetchFormGroupDone(data));
    return true;
  } catch (e) {
    dispatch(fetchFormGroupFailed(e));
    return false;
  }
};
/////////////

/////////////

export const fetchGlobalDictionariesStart = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_START,
  payload,
});
export const fetchGlobalDictionariesDone = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_DONE,
  payload,
});
export const fetchGlobalDictionariesFailed = (payload) => ({
  type: FETCH_GLOBAL_DICTIONARIES_FAILED,
  payload,
});

export const fetchGlobalDictionaries = () => async (dispatch) => {
  dispatch(fetchGlobalDictionariesStart());
  try {
    const data = (
      await getAxiosInstance().get(`/api/form_layouts/saved_fields`)
    ).data;

    dispatch(fetchGlobalDictionariesDone(data));
    return data;
  } catch (e) {
    dispatch(fetchGlobalDictionariesFailed(e));
    return null;
  }
};

/////////////

export const createFilledFormDataStart = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_START,
  payload,
});
export const createFilledFormDataDone = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_DONE,
  payload,
});
export const createFilledFormDataFailed = (payload) => ({
  type: CREATE_FILLED_FORM_DATA_FAILED,
  payload,
});

export const createFilledFormData = ({
  formId,
  scheduledFormId,
  values,
  arrayValues,
  files,
  notes,
  fieldAlternativeAnswer,
  draft,
}) => async (dispatch) => {
  dispatch(createFilledFormDataStart());
  try {
    const payload = {
      form: {
        id: formId,
      },
    };
    const formMetadata = (
      await getAxiosInstance().post(`/api/form_metadata`, payload)
    ).data;
    dispatch(createFilledFormDataDone(formMetadata));

    return await dispatch(
      saveFilledFormData({
        formId,
        scheduledFormId,
        formMetadataId: formMetadata.id,
        values,
        arrayValues,
        files,
        notes,
        fieldAlternativeAnswer,
        draft,
      })
    );
  } catch (e) {
    dispatch(createFilledFormDataFailed(e));
    throw e;
  }
};

/////////////

export const saveFilledFormDataStart = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_START,
  payload,
});
export const saveFilledFormDataDone = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_DONE,
  payload,
});
export const saveFilledFormDataFailed = (payload) => ({
  type: SAVE_FILLED_FORM_DATA_FAILED,
  payload,
});

export const saveFilledFormData = ({
  formId,
  formMetadataId,
  scheduledFormId,
  values,
  arrayValues,
  files,
  fieldAlternativeAnswer,
  draft,
  notes,
}) => async (dispatch) => {
  dispatch(saveFilledFormDataStart());
  try {
    const payload = {
      formId,
      scheduledFormId,
      data: values,
      arrayData: arrayValues,
      noteData: notes,
      filesDataUUID: files,
      formMetadataId,
      fieldAlternativeAnswer,
    };
    const result = (
      await getAxiosInstance().post(`/api/form_data`, payload, {
        params: { draft },
      })
    ).data;
    dispatch(saveFilledFormDataDone(result));

    return result;
  } catch (e) {
    dispatch(saveFilledFormDataFailed(e));
    throw e;
  }
};

export const editFilledFormDataStart = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_START,
  payload,
});
export const editFilledFormDataDone = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_DONE,
  payload,
});
export const editFilledFormDataFailed = (payload) => ({
  type: EDIT_FILLED_FORM_DATA_FAILED,
  payload,
});

export const editFilledFormData = (
  {
    formId,
    formMetadataId,
    scheduledFormId,
    values,
    arrayValues,
    fieldAlternativeAnswer,
    files,
    draft,
    notes,
  },
  formDataId
) => async (dispatch) => {
  dispatch(editFilledFormDataStart());
  try {
    const payload = {
      formId,
      scheduledFormId,
      data: values,
      arrayData: arrayValues,
      formMetadataId,
      fieldAlternativeAnswer,
      filesDataUUID: files,
      noteData: notes,
    };
    const result = (
      await getAxiosInstance().put(`/api/form_data/${formDataId}`, payload, {
        params: {
          draft,
        },
      })
    ).data;
    dispatch(editFilledFormDataDone(result));

    return result;
  } catch (e) {
    dispatch(editFilledFormDataFailed(e));
    if (
      e.response.data.code === "500" &&
      e.response.data.message === "HTTP 404 Not Found"
    ) {
      return false;
    }
    throw e;
  }
};

/////////////

export const fetchFilledFormsStart = (payload) => ({
  type: FETCH_FILLED_FORMS_START,
  payload,
});
export const fetchFilledFormsDone = (payload) => ({
  type: FETCH_FILLED_FORMS_DONE,
  payload,
});
export const fetchFilledFormsFailed = (payload) => ({
  type: FETCH_FILLED_FORMS_FAILED,
  payload,
});

export const fetchFilledForms = (formId) => async (dispatch) => {
  dispatch(fetchFilledFormsStart());
  try {
    const result = (
      await getAxiosInstance().get(`/api/form_data/by_form_id/${formId}`)
    ).data;
    dispatch(
      fetchFilledFormsDone({
        formId,
        data: result,
      })
    );

    return result;
  } catch (e) {
    dispatch(fetchFilledFormsFailed(e));
    return false;
  }
};

export const fetchFilledFormsExtended = (
  formId,
  { showMissedForms, ...body }
) => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + START });
  try {
    const result = (
      await getAxiosInstance().post(
        `/api/form_data/by_form_id_extended/${formId}`,
        body,
        {
          params: {
            showMissedForms,
          },
        }
      )
    ).data;
    dispatch({
      type: FETCH_FILLED_FORMS_EXTENDED + DONE,
      payload: {
        formId,
        result,
      },
    });

    return result;
  } catch (e) {
    dispatch({ type: FETCH_FILLED_FORMS_EXTENDED + FAILED, payload: e });
    return false;
  }
};

const recoverPasswordStart = (payload) => ({
  type: RECOVER_PASSWORD_START,
  payload,
});
const recoverPasswordDone = (payload) => ({
  type: RECOVER_PASSWORD_DONE,
  payload,
});
const recoverPasswordFailed = (payload) => ({
  type: RECOVER_PASSWORD_FAILED,
  payload,
});
export const recoverPassword = ({ email, phone }) => async (dispatch) => {
  dispatch(recoverPasswordStart());
  try {
    const result = await getAxiosInstance().post(`/api/auth/recover_password`, {
      email,
      phone,
      lang: "pl",
    });
    const data = result.data;
    dispatch(recoverPasswordDone(data));

    return result;
  } catch (e) {
    dispatch(recoverPasswordFailed(e));
    return false;
  }
};

const resetByMailPasswordStart = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_START,
  payload,
});
const resetByMailPasswordDone = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_DONE,
  payload,
});
const resetByMailPasswordFailed = (payload) => ({
  type: RESET_BY_MAIL_PASSWORD_FAILED,
  payload,
});

export const resetByMailPassword = ({
  email,
  resetId,
  newPassword,
}) => async (dispatch) => {
  dispatch(resetByMailPasswordStart());
  try {
    await getAxiosInstance().post(`/api/auth/change_password`, {
      email,
      resetId,
      newPassword,
    });
    dispatch(resetByMailPasswordDone());
    return true;
  } catch (e) {
    dispatch(resetByMailPasswordFailed(e));
    return false;
  }
};

export const alertAdd = (payload) => ({ type: ALERT_SHOW, payload });
export const alertHide = (payload) => ({ type: ALERT_HIDE, payload });
export const alertHideCustomId = (payload) => ({
  type: ALERT_HIDE_CUSTOM_ID,
  payload,
});
export const alertTimeout = (payload) => ({ type: ALERT_TIMEOUT, payload });

const sendCommentStart = () => ({ type: SEND_COMMENT_START });
const sendCommentDone = () => ({ type: SEND_COMMENT_DONE });
const sendCommentFailed = () => ({ type: SEND_COMMENT_FAILED });
export const sendComment = ({ url, text }) => async (dispatch) => {
  dispatch(sendCommentStart());
  try {
    const result = await getAxiosInstance().post(`/api/site-comment`, {
      url,
      text,
    });
    dispatch(sendCommentDone());

    return result;
  } catch (e) {
    dispatch(sendCommentFailed(e));
    return false;
  }
};

export const activateForm = ({ id }) => async (dispatch) => {
  dispatch({ type: ACTIVATE_FORM + START });
  try {
    const result = await getAxiosInstance().put(`/api/forms/${id}/activate`);
    dispatch({ type: ACTIVATE_FORM + DONE, payload: result.data });

    return result.data;
  } catch (e) {
    dispatch({ type: ACTIVATE_FORM + FAILED, payload: e });
    throw e;
  }
};

export const removeUserStart = (payload) => ({ type: REMOVE_USER, payload });
export const removeUserDone = (payload) => ({
  type: REMOVE_USER + DONE,
  payload,
});
export const removeUserFailed = (payload) => ({
  type: REMOVE_USER + FAILED,
  payload,
});

export const removeUser = (userId) => async (dispatch) => {
  dispatch(removeUserStart());
  try {
    const result = await getAxiosInstance().delete(`/api/v1/users/${userId}`);
    dispatch(removeUserDone(result));
    dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(removeUserFailed(e));
    return false;
  }
};

export const editUserStart = (payload) => ({ type: EDIT_USER, payload });
export const editUserDone = (payload) => ({
  type: EDIT_USER + DONE,
  payload,
});
export const editUserFailed = (payload) => ({
  type: EDIT_USER + FAILED,
  payload,
});

export const editUser = (user) => async (dispatch) => {
  dispatch(editUserStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/${user.id}/update`,
      {
        hospitalIdentifier: user.hospitalIdentifier,
        firstName: user.firstName,
        surname: user.surname,
        ...(user.phone && user.phone !== "+48"
          ? { phone: user.phone }
          : { phone: null }),
        mail: user.mail,
        title: user.title,
        description: user.description,
        gender: user.gender,
        address: user.address,
        // enableAllForms: user.enableAllForms,
        enableProfileDataEdition: user.enableProfileDataEdition,
        ...(user.emergencyContact
          ? { emergencyContact: user.emergencyContact }
          : {}),
      }
    );
    const my = await getAxiosInstance().get("/api/persons/my");

    dispatch(editUserDone({ result: result, my: my.data }));
    dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(editUserFailed(e));
    return e.response;
  }
};

export const fetchMatchingUsersStart = (payload) => ({
  type: FETCH_MATCHING_USERS + START,
  payload,
});
export const fetchMatchingUsersDone = (payload) => ({
  type: FETCH_MATCHING_USERS + DONE,
  payload,
});
export const fetchMatchingUsersFailed = (payload) => ({
  type: FETCH_MATCHING_USERS + FAILED,
  payload,
});

export const fetchMatchingUsers = (data) => async (dispatch) => {
  dispatch(fetchMatchingUsersStart());
  try {
    const result = await getAxiosInstance().post(
      `/api/organizations/fetch_matching_users`,
      data
    );
    dispatch(fetchMatchingUsersDone({ result: result }));
    return result;
  } catch (e) {
    dispatch(fetchMatchingUsersFailed(e));
    return e.response;
  }
};

export const activateUserStart = (payload) => ({
  type: ACTIVATE_USER,
  payload,
});
export const activateUserDone = (payload) => ({
  type: ACTIVATE_USER + DONE,
  payload,
});
export const activateUserFailed = (payload) => ({
  type: ACTIVATE_USER + FAILED,
  payload,
});

export const activateUser = (userId) => async (dispatch) => {
  dispatch(activateUserStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/v1/users/${userId}/activate`
    );
    dispatch(activateUserDone(result));
    dispatch(fetchOrgUsers());

    return result;
  } catch (e) {
    dispatch(activateUserFailed(e));
    return false;
  }
};

export const updateEntitledUsersStart = (payload) => ({
  type: UPDATE_ENTITLED_USERS + START,
  payload,
});
export const updateEntitledUsersDone = (payload) => ({
  type: UPDATE_ENTITLED_USERS + DONE,
  payload,
});
export const updateEntitledUsersFailed = (payload) => ({
  type: UPDATE_ENTITLED_USERS + FAILED,
  payload,
});

export const updateEntitledUsers = (formId, emails) => async (dispatch) => {
  dispatch(updateEntitledUsersStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/forms/${formId}/entitled_users`,
      {
        users: emails.map((email) => ({
          username: email,
        })),
      }
    );
    dispatch(updateEntitledUsersDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateEntitledUsersFailed(e));
    return false;
  }
};

export const updateUsersAccessToGroupStart = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + START,
  payload,
});
export const updateUsersAccessToGroupDone = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + DONE,
  payload,
});
export const updateUsersAccessToGroupFailed = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_GROUP + FAILED,
  payload,
});

export const updateUsersAccessToGroup = (groupId, usersIDs) => async (
  dispatch
) => {
  dispatch(updateUsersAccessToGroupStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/form_group/${groupId}/allowed_users`,
      usersIDs
    );
    dispatch(updateUsersAccessToGroupDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateUsersAccessToGroupFailed(e));
    return false;
  }
};

export const updateUsersAccessToFormStart = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + START,
  payload,
});
export const updateUsersAccessToFormDone = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + DONE,
  payload,
});
export const updateUsersAccessToFormFailed = (payload) => ({
  type: UPDATE_USERS_ACCESS_TO_FORM + FAILED,
  payload,
});

export const updateUsersAccessToForm = (formId, selectedUsers) => async (
  dispatch
) => {
  dispatch(updateUsersAccessToFormStart());
  try {
    const result = await getAxiosInstance().put(
      `/api/forms/${formId}/allowed_users`,
      selectedUsers
    );
    dispatch(updateUsersAccessToFormDone(result.data));

    return result.data;
  } catch (e) {
    dispatch(updateUsersAccessToFormFailed(e));
    return false;
  }
};

export const fetchFormEditions = (formId) => async (dispatch) => {
  dispatch({ type: FETCH_FORM_EDITIONS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/editions_by_form_id/${formId}`
    );
    dispatch({ type: FETCH_FORM_EDITIONS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORM_EDITIONS + FAILED, payload: e });
  }
};

export const fetchOldFormEditions = (formId) => async (dispatch) => {
  dispatch({ type: FETCH_OLD_FORM_EDITIONS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/forms/${formId}/old_versions`
    );
    dispatch({ type: FETCH_OLD_FORM_EDITIONS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_OLD_FORM_EDITIONS + FAILED, payload: e });
  }
};

export const fetchDataAsCSV = ({
  formId,
  includePersonalData,
  personId,
  showMissedForms,
}) => async (dispatch) => {
  dispatch({ type: FETCH_DATA_AS_CSV + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/csv/${formId}`,
      {
        params: {
          includePersonalData,
          includeMissingData: showMissedForms,
          personId,
        },
      }
    );
    dispatch({ type: FETCH_DATA_AS_CSV + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_DATA_AS_CSV + FAILED, payload: e });
  }
};

export const addItemToCart = (payload) => async (dispatch) => {
  dispatch({ type: ADD_ITEM_TO_CART + START });
  try {
    const result = await getAxiosInstance().post(`/api/cart`, payload);
    dispatch({ type: ADD_ITEM_TO_CART + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: ADD_ITEM_TO_CART + FAILED, payload: e });
  }
};

export const editItemCart = (id, payload) => async (dispatch) => {
  dispatch({ type: EDIT_ITEM_CART + START });
  try {
    const result = await getAxiosInstance().put(`/api/cart/${id}`, payload);
    dispatch({ type: EDIT_ITEM_CART + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: EDIT_ITEM_CART + FAILED, payload: e });
  }
};

export const removeFromCart = (id) => async (dispatch) => {
  dispatch({ type: REMOVE_ITEM_FROM_CART + START });
  try {
    const result = await getAxiosInstance().delete(`/api/cart/${id}`);
    dispatch({ type: REMOVE_ITEM_FROM_CART + DONE, payload: id });
    return result.data;
  } catch (e) {
    dispatch({ type: REMOVE_ITEM_FROM_CART + FAILED, payload: e });
  }
};

export const fetchAllMyTests = () => async (dispatch) => {
  dispatch({ type: FETCH_ALL_MY_TESTS + START });
  try {
    const result = await getAxiosInstance().get(`/api/form_data/all/my`, {
      params: {
        sortBy: "createdBy",
        sortOrder: "asc",
      },
    });
    dispatch({ type: FETCH_ALL_MY_TESTS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ALL_MY_TESTS + FAILED, payload: e });
  }
};

export const fetchFilledTests = (params) => async (dispatch) => {
  dispatch({ type: FETCH_FILLED_TESTS + START });
  try {
    const result = await getAxiosInstance().get("/api/form_data/all/my", {
      params,
    });
    dispatch({ type: FETCH_FILLED_TESTS + DONE, payload: result.data });

    return result.data;
  } catch (payload) {
    dispatch({ type: FETCH_FILLED_TESTS + FAILED, payload });
    return false;
  }
};

export const fetchActivatedKits = () => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVATED_KITS + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/forms/scheduled/activated`
    );
    dispatch({ type: FETCH_ACTIVATED_KITS + DONE, payload: result.data });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ACTIVATED_KITS + FAILED, payload: e });
  }
};

export const toggleRequestedSharingByOwner = (scheduledFormId) => async (
  dispatch
) => {
  dispatch({ type: TOGGLE_REQUESTED_SHARING_BY_OWNER + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/forms/scheduled/${scheduledFormId}/toggle-requested-sharing-by-owner`
    );
    dispatch({
      type: TOGGLE_REQUESTED_SHARING_BY_OWNER + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: TOGGLE_REQUESTED_SHARING_BY_OWNER + FAILED, payload: e });
  }
};

export const updateRequestedSharingByOwner = (
  scheduledFormId,
  enable
) => async (dispatch) => {
  dispatch({ type: UPDATE_REQUESTED_SHARING_BY_OWNER + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/forms/scheduled/${scheduledFormId}/${
        enable ? "enable" : "disable"
      }-requested-sharing-by-owner`
    );
    dispatch({
      type: UPDATE_REQUESTED_SHARING_BY_OWNER + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: UPDATE_REQUESTED_SHARING_BY_OWNER + FAILED, payload: e });
  }
};

export const updateSharingFormData = (formDataId, enable) => async (
  dispatch
) => {
  dispatch({ type: UPDATE_FORM_DATA_IS_SHARED + START });
  try {
    const result = await getAxiosInstance().patch(
      `/api/form_data/${formDataId}/${enable ? "enable" : "disable"}-sharing`
    );
    dispatch({
      type: UPDATE_FORM_DATA_IS_SHARED + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: UPDATE_FORM_DATA_IS_SHARED + FAILED, payload: e });
  }
};

export const setAppBarTitle = (title) => async (dispatch) => {
  dispatch({
    type: SET_APP_BAR_TITLE,
    payload: { title },
  });
};

export const fetchTerms = (orgId) => async (dispatch) => {
  dispatch({ type: FETCH_ALL_TERMS + START });
  try {
    const result = await getAxiosInstance().get(`/api/organizations/terms`);
    dispatch({
      type: FETCH_ALL_TERMS + DONE,
      payload: result.data,
      orgId,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ALL_TERMS + FAILED, payload: e });
  }
};

/**
 * This will fetch the following order details:
 * - all kits that were part of this order
 * - all tests that were in the kit
 * - all results of the tests that were already conducted
 * @param data
 * @returns {function(*): Promise<*|undefined>}
 */
export const fetchOrderDetailsByOrderId = (orderId) => async (dispatch) => {
  dispatch({ type: FETCH_ORDER_DETAILS_BY_ORDER_ID + START });
  try {
    const result = await getAxiosInstance().get(`/api/orders/${orderId}`);
    dispatch({
      type: FETCH_ORDER_DETAILS_BY_ORDER_ID + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_ORDER_DETAILS_BY_ORDER_ID + FAILED, payload: e });
  }
};

export const fetchFormData = (formDataId) => async (dispatch) => {
  dispatch({ type: FETCH_FORM_DATA + START });
  try {
    const result = await getAxiosInstance().get(`/api/form_data/${formDataId}`);
    dispatch({
      type: FETCH_FORM_DATA + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORM_DATA + FAILED, payload: e });
    return e.response;
  }
};

export const fetchUploadableFileTypes = (formDataId) => async (dispatch) => {
  dispatch({ type: FETCH_UPLOADABLE_FILE_TYPES + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/form_data/upload/file_types`
    );
    dispatch({
      type: FETCH_UPLOADABLE_FILE_TYPES + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_UPLOADABLE_FILE_TYPES + FAILED, payload: e });
  }
};

export const fetchFormsScheduledForFuture = () => async (dispatch) => {
  dispatch({ type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + START });
  try {
    const result = await getAxiosInstance().get(
      `/api/forms/scheduled-for-future`
    );
    dispatch({
      type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + DONE,
      payload: result.data,
    });
    return result.data;
  } catch (e) {
    dispatch({ type: FETCH_FORMS_SCHEDULED_FOR_FUTURE + FAILED, payload: e });
  }
};

export const resetGivenUserPassword = (id) => async (dispatch) => {
  dispatch({ type: RESET_GIVEN_USER_PASSWORD + START });
  try {
    const result = await getAxiosInstance().put(
      `/api/persons/${id}/reset_password`
    );
    dispatch({
      type: RESET_GIVEN_USER_PASSWORD + DONE,
      payload: result.data,
    });
    return result;
  } catch (e) {
    dispatch({ type: RESET_GIVEN_USER_PASSWORD + FAILED, payload: e });
    return e.response;
  }
};

export const fetchApiKeys = () => async (dispatch) => {
  dispatch({ type: FETCH_API_KEYS + START });
  try {
    const result = await getAxiosInstance().get(`/api/tokens`);
    dispatch({
      type: FETCH_API_KEYS + DONE,
    });
    return result;
  } catch (e) {
    dispatch({ type: FETCH_API_KEYS + FAILED, payload: e });
    return e.response;
  }
};

export const addApiKey = (payload) => async (dispatch) => {
  dispatch({ type: ADD_API_KEY + START });
  try {
    const result = await getAxiosInstance().post(`/api/tokens`, {
      ...payload,
    });
    dispatch({
      type: ADD_API_KEY + DONE,
      payload: result.data,
    });
    return result;
  } catch (e) {
    dispatch({ type: ADD_API_KEY + FAILED, payload: e });
    return e.response;
  }
};

export const deleteApiKey = (tokenId) => async (dispatch) => {
  dispatch({ type: DELEETE_API_KEY + START });
  try {
    const result = await getAxiosInstance().delete(`/api/tokens`, {
      params: {
        tokenId,
      },
    });
    dispatch({
      type: DELEETE_API_KEY + DONE,
    });
    return result;
  } catch (e) {
    dispatch({ type: DELEETE_API_KEY + FAILED, payload: e });
    return e.response;
  }
};

export const fetchScheduledForm = (id) => async (dispatch) => {
  dispatch({ type: FETCH_SCHEDULED_FORM + START });
  try {
    const form = (await getAxiosInstance().get(`/api/forms/scheduled/${id}`))
      .data;

    dispatch({ type: FETCH_SCHEDULED_FORM + DONE, payload: form });
    return form;
  } catch (e) {
    dispatch({ type: FETCH_SCHEDULED_FORM + FAILED, payload: e });
    throw e.response;
  }
};

export const fetchHasSingleScheduledForm = () => async (dispatch) => {
  dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + START });
  try {
    const data = (
      await getAxiosInstance().get(`/api/forms/has-only-one-scheduled-form`)
    ).data;

    dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + DONE, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: FETCH_HAS_SINGLE_SCHEDULED_FORM + FAILED, payload: e });
    throw e.response;
  }
};

export const checkMyIdentity = () => async (dispatch) => {
  try {
    const result = await getAxiosInstance().get(`/api/persons/my`);
    return result;
  } catch (e) {
    return e.response;
  }
};

export const toggleGlobalTheme = () => {
  return {
    type: TOGGLE_GLOBAL_THEME,
  };
};

export const readGlobalTheme = () => {
  return {
    type: READ_GLOBAL_THEME,
  };
};

export const smallFontSize = () => {
  return {
    type: SMALL_FONT_SIZE,
  };
};
export const mediumFontSize = () => {
  return {
    type: MEDIUM_FONT_SIZE,
  };
};
export const largeFontSize = () => {
  return {
    type: LARGE_FONT_SIZE,
  };
};

export const fetchConfig = () => async (dispatch) => {
  dispatch({ type: FETCH_CONFIG + START });
  try {
    const result = await getAxiosInstance().get(`/api/config`);
    dispatch({ type: FETCH_CONFIG + DONE, payload: result.data });
    return result.response;
  } catch (e) {
    dispatch({ type: FETCH_CONFIG + FAILED });
    return e.response;
  }
};

export const clearAllFormData = () => {
  return {
    type: CLEAR_ALL_FORM,
  };
};
